/**
 * Qo'lda yozilgan LAVOZIM NOMI: tozalash, solishtirish va kod yasash.
 *
 * Lavozim ma'lumotnomasi endi tayyor ro'yxat emas — ish joyini tahrirlagan
 * odam yangi nomni shu yerda yozadi va u ma'lumotnomaga qo'shiladi. Shuning
 * uchun TAKRORNI TOPISH mantig'i bu faylda, sof funksiyalarda turadi: bir
 * yilda «Yo'l ustasi», «yo'l  ustasi» va «Yoʻl ustasi» uch xil satrga
 * aylanib ketmasin.
 */
/** Ortiqcha probellar tozalangan, EKRANGA CHIQADIGAN nom. */
export const normalizePositionName = (raw) => raw.trim().replace(/\s+/g, ' ');
/**
 * O'zbek matnidagi apostrof shakllari.
 *
 * `oʻ`/`gʻ` uchun to'g'ri belgi `U+02BB`, lekin klaviaturadan odatda oddiy
 * `'` teriladi, Word esa uni jimgina `’` ga almashtiradi. Uchalasi ham bir
 * xil so'z bo'lgani uchun solishtirishda farqi qolmasligi kerak.
 */
const APOSTROPHES = /['`´‘’ʻʼ]/g;
/**
 * SOLISHTIRISH KALITI — registr ham, apostrof shakli ham farq qilmaydi.
 *
 * Bazada saqlanmaydi: lavozimlar jadvali kichkina (o'nlab satr) va uni
 * butunlay o'qib, kalit bo'yicha solishtirish ustun qo'shib, migratsiya
 * yozib, indeksni qo'llab-quvvatlashdan arzonroq.
 */
export const positionNameKey = (raw) => normalizePositionName(raw).replace(APOSTROPHES, '').toLowerCase();
/** `code` ustuni 40 belgi (`position.entity.ts`). */
const MAX_CODE = 40;
/** Lotin harfi umuman qolmasa (masalan kirill nom) — shu asos ishlatiladi. */
const FALLBACK = 'LAVOZIM';
const slugOf = (name) => normalizePositionName(name)
    .replace(APOSTROPHES, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
/** Oxiridagi chiziqchani olib tashlab, kerakli uzunlikka kesadi. */
const cut = (base, limit) => base.slice(0, limit).replace(/-+$/, '');
/**
 * Nomdan KOD yasaydi — «Yo'l ustasi» → `YOL-USTASI`.
 *
 * Kodni odam terMAYDI: u faqat ichki, barqaror belgi bo'lib qoladi (seedlar
 * lavozimni kod bilan topadi). Band bo'lsa `-2`, `-3` qo'shiladi, chunki
 * `code` yagona indeks ostida.
 */
export const positionCodeOf = (name, taken) => {
    const base = cut(slugOf(name), MAX_CODE) || FALLBACK;
    if (!taken.has(base))
        return base;
    /* Chegara `taken` hajmidan kelib chiqadi: har urinish bitta band kodni
       "yeydi", ya'ni bo'sh kod albatta shu oraliqda topiladi. */
    for (let n = 2; n <= taken.size + 2; n += 1) {
        const suffix = `-${n}`;
        const candidate = `${cut(base, MAX_CODE - suffix.length)}${suffix}`;
        if (!taken.has(candidate))
            return candidate;
    }
    /* Bu yerga tushib bo'lmaydi; tushsa — yuqoridagi mulohaza buzilgan. */
    throw new Error('Lavozim uchun bo\'sh kod topilmadi');
};
//# sourceMappingURL=position-name.js.map